// RegistrationForm.js
import React from "react";
import { InputFieldLogin } from "./InputField";
import PasswordField from "./PasswordField";

export const Validation = ({
  password,
  isValidLength,
  isValidUpperCase,
  isValidLowerCase,
  isValidNumber,
  isValidSpecialCharacter,
}) => {
  const requirements = [
    { text: "8 caratteri", isValid: isValidLength },
    { text: "1 minuscola", isValid: isValidLowerCase },
    { text: "1 maiuscola", isValid: isValidUpperCase },
    { text: "1 numero", isValid: isValidNumber },
    { text: "1 carattere speciale", isValid: isValidSpecialCharacter },
  ];
  return (
    <ul className="text-left">
      {requirements.map((requirement, index) => (
        <li
          key={index}
          className={`${
            password && requirement.isValid ? "text-green-500" : "text-red-500"
          } relative flex items-center`}
        >
          {requirement.text}
          {password && requirement.isValid ? (
            <svg
              className="ml-3 fill-green-500"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
            >
              <path d="m2.251 12.322 7.27 6.492a.75.75 0 0 0 1.058-.06l11.23-12.502a.749.749 0 1 0-1.116-1.001L9.96 17.196l-6.71-5.993a.749.749 0 1 0-1.001 1.118" />
            </svg>
          ) : (
            <svg
              className="ml-3 fill-red-500"
              clipRule="evenodd"
              fillRule="evenodd"
              strokeLinejoin="round"
              strokeMiterlimit="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
            >
              <path d="m12 10.93 5.719-5.72a.749.749 0 1 1 1.062 1.062l-5.72 5.719 5.719 5.719a.75.75 0 1 1-1.061 1.062L12 13.053l-5.719 5.719A.75.75 0 0 1 5.22 17.71l5.719-5.719-5.72-5.719A.752.752 0 0 1 6.281 5.21z" />
            </svg>
          )}
        </li>
      ))}
    </ul>
  );
};

const RegistrationForm = ({
  isValidLength,
  isValidLowerCase,
  isValidUpperCase,
  isValidNumber,
  isValidSpecialCharacter,
  handleRegistration,
  name,
  setName,
  lastname,
  setLastName,
  email,
  setEmail,
  password,
  setPassword,
  setToggleForm,
  isPasswordHidden,
  setHidePassword,
  handleEmail,
  handlePassword,
  userAlreadyExist,
  emailSelectedRegistration,
  setEmailSelectedRegistration,
  nameSelected,
  setNameSelected,
  lastNameSelected,
  setLastNameSelected,
  passwordSelectedRegistration,
  setPasswordSelectedRegistration,
  registrationError,
  emailError,
  passwordError,
  firstNameError,
  lastNameError,
}) => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md mb-10">
      <h1 className="text-4xl mt-2 mb-8 font-bold text-gray-600">Registrati</h1>
      {registrationError && (
        <div className="text-red-600 bg-red-100 border border-red-400 p-2 rounded mb-4">
          {registrationError}
        </div>
      )}
      <form onSubmit={handleRegistration}>
        <InputFieldLogin
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onFocus={() => setNameSelected(true)}
          onBlur={() => setNameSelected(false)}
          selected={nameSelected}
          label="Nome"
        />
        {firstNameError && (
          <div className="text-red-600 text-left py-2">{firstNameError}</div>
        )}
        <InputFieldLogin
          id="lastname"
          type="text"
          value={lastname}
          onChange={(e) => setLastName(e.target.value)}
          onFocus={() => setLastNameSelected(true)}
          onBlur={() => setLastNameSelected(false)}
          selected={lastNameSelected}
          label="Cognome"
        />
        {lastNameError && (
          <div className="text-red-600 text-left py-2">{lastNameError}</div>
        )}
        <InputFieldLogin
          id="email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={() => setEmailSelectedRegistration(true)}
          onBlur={() => setEmailSelectedRegistration(false)}
          selected={emailSelectedRegistration}
          label="Email"
        />
        {emailError && (
          <div className="text-red-600 text-left py-2">{emailError}</div>
        )}
        <PasswordField
          id="password"
          value={password}
          onChange={(e) => handlePassword(e.target.value)}
          onFocus={() => setPasswordSelectedRegistration(true)}
          onBlur={() => setPasswordSelectedRegistration(false)}
          selected={passwordSelectedRegistration}
          isPasswordHidden={isPasswordHidden}
          togglePasswordVisibility={() => setHidePassword(!isPasswordHidden)}
          label={"Password"}
        />
        {passwordError && (
          <div className="text-red-600 text-left py-2">{passwordError}</div>
        )}
        <div
          className={`transition-all duration-[600ms] ease-in-out bg-white ${
            passwordSelectedRegistration ? "max-h-40" : "max-h-0"
          } relative overflow-hidden`}
        >
          <Validation
            password={password}
            isValidLength={isValidLength}
            isValidUpperCase={isValidUpperCase}
            isValidLowerCase={isValidLowerCase}
            isValidNumber={isValidNumber}
            isValidSpecialCharacter={isValidSpecialCharacter}
          />
        </div>
        <div
          className={`bg-white ${
            userAlreadyExist ? "max-h-40" : "max-h-0"
          } relative overflow-hidden`}
        >
          <p className="text-red-500">
            Sembra che un altro account sia già associato a questa email.
          </p>
        </div>
        <button
          type="submit"
          className="mt-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
        >
          Registrati
        </button>
        <br />
        <p className="mt-4">
          Hai già un account?{" "}
          <button
            type="button"
            onClick={() => setToggleForm((prevState) => !prevState)}
            className="text-blue-600 hover:underline"
          >
            Accedi ora
          </button>
        </p>
      </form>
    </div>
  </div>
);

export default RegistrationForm;
